<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button
    (clicked)="navigateBack()"
    #backButton
    [project]="project"
    [floorplanGroup]="FloorplanMenuType.GROUP"
  >
  </app-configuration-wizard-back-button>

  <odx-content-box class="group-configuration-container">
    <odx-content-box-header>
      <div class="flex">
        <div odxLayout="flex gap-small">
          <h5 class="odx-title-5" i18n="@@groupConfiguration.title">Gruppe verwalten</h5>
          <app-group-number-chip [group]="group"></app-group-number-chip>
        </div>
        <odx-action-group>
          <button odxButton (click)="openDeleteGroupModal()" variant="ghost">
            <odx-icon name="delete" alignleft></odx-icon>
            <span i18n="@@groupConfiguration.button.deleteGroup">Gruppe auflösen</span>
          </button>
        </odx-action-group>
      </div>
    </odx-content-box-header>

    <form odxForm [formGroup]="groupNameForm">
      <odx-form-field i18n-label="@@groupConfiguration.form.name.label" label="Gruppenname">
        <input
          formControlName="name"
          odxFormFieldControl
          i18n-placeholder="@@groupConfiguration.form.name.input"
          placeholder="Gruppenname"
        />
        <ng-template odxFormFieldError="required">
          <ng-container i18n="@@groupConfiguration.form.error.groupNameRequired">Gruppennamen angeben </ng-container>
        </ng-template>
        <ng-template odxFormFieldError="maxlength">
          <ng-container i18n="@@groupConfiguration.form.error.groupNameTooLong">
            Gruppenname darf nicht länger als 50 Zeichen sein
          </ng-container>
        </ng-template>
      </odx-form-field>
    </form>
    <div class="flex">
      <h5 class="odx-title-5" i18n="@@groupConfiguration.table.title">Produktliste</h5>
      <odx-action-group>
        <button odxButton (click)="addProducts()" variant="primary">
          <odx-icon name="plus" alignleft></odx-icon>
          <span i18n="@@groupConfiguration.button.addProducts">Produkte hinzufügen</span>
        </button>
      </odx-action-group>
    </div>

    <app-group-configuration-table
      #groupTable
      [group]="group"
      [floorplan]="this.floorplan"
      [project]="this.project"
      [productsToDisplay]="productsToDisplay"
      (selectedProductsChanged)="onSelectedProductsChanged($event)"
    ></app-group-configuration-table>

    @if (this.selectedProducts.length > 0) {
      <odx-bar>
        <button odxBarButton (click)="deselect()">
          <odx-icon size="large" name="close"></odx-icon>
        </button>
        <label odxBarLabel i18n="@@groupConfiguration.bar.label"> {{ this.selectedProducts.length }} Produkt(e) ausgewählt</label>
        <button odxBarButton (click)="removeProductsFromGroup()" [odxTooltip]="tooltipTextRemoveProducts">
          <odx-icon size="large" name="delete"></odx-icon>
        </button>
      </odx-bar>
    }
  </odx-content-box>
</div>
